import React from 'react'
import styled from 'styled-components'

import { header5, title } from 'styles/texts'

import Modal from 'components/Modal'
import ButtonComponent from 'components/Button'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 20px 30px;

  @media (min-width: 640px) {
    padding: 20px 60px 60px;
  }
`

const Heading = styled.div`
  ${header5};
`

const Paragraph = styled.div`
  margin: 11px 0 40px;
  ${title};
`

const Button = styled(ButtonComponent)`
  align-self: center;
`

class WelcomeMessage extends React.Component {
  state = {
    showModal: true,
  }

  render() {
    return (
      <Modal
        title="Velkommen til Spir!"
        small={true}
        isOpen={this.state.showModal}
        onRequestClose={() => this.setState({ showModal: false })}>
        <Wrapper>
          <Heading>Kult!</Heading>
          <Paragraph>
            Vi skal hjelpe deg med profilen din så du får jobb{' '}
            <span role="img" aria-label="">
              👋
            </span>
          </Paragraph>
          <Button
            size="large"
            onClick={() => this.setState({ showModal: false })}>
            Hopp ut i det
          </Button>
        </Wrapper>
      </Modal>
    )
  }
}

export default WelcomeMessage



// WEBPACK FOOTER //
// ./src/components/WelcomeMessage.js